import React, { useState,useEffect } from "react"; 
import BreadCrumb from "../../Components/Common/BreadCrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  Label,
  FormFeedback,
  Form,
} from "reactstrap";

// Redux
import { useDispatch } from "react-redux";
import {  updateProduct,delProductImg, fetchProductCategories } from '../../utils/products';

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import classnames from "classnames";
import Dropzone from "react-dropzone";
import { Link, useNavigate,useLocation } from "react-router-dom";

//formik
import { useFormik } from "formik";
import * as Yup from "yup";

// Import React FilePond
import { registerPlugin } from "react-filepond";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Import FilePond styles
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

import { baseURL, addProductImage, addProductImageList } from "../../utils/imageapi";
import { ToastContainer, toast } from 'react-toastify';
import { nfcAll,nfcAdd, nfcUpdate,getProductNFC } from "../../utils/nfc";
import { fetchProductDetail } from '../../utils/products';

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const EditProduct = (props) => {
  document.title = "Edit Product | SeedNations";
 
  // Add this function for error notifications
  const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };
   
  const [nfcId, setNfcId] = useState(null);
  const [nfcIdold, setNfcIdold] = useState(null);


  const [battery_required, setbattery_required] = useState(null);
  const [selectedNft, setSelectedNft] = useState(null); 
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedVisibility, setselectedVisibility] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [editor, setEditor] = useState(null);
  const [about, setAbout] = useState('');

  const [mainImageUrl, setMainImageUrl] = useState(""); // Store uploaded main image URL 
  const [detail, setDetailData ] = useState(null); 
  
  const [loading, setLoading] = useState(true);
  const location = useLocation(); // Get current location
  const searchParams = new URLSearchParams(location.search);
  const productId = searchParams.get("productId"); // Extract productId from query params
  console.log('ProductId', productId);
  // Removed excessive logging to prevent console spam
  
  // Early validation for productId
  if (!productId) {
    console.error('No productId found in URL parameters');
  }
  const [selectedTags, setSelectedTags] = useState([]);

  // 预定义的标签选项
  const defaultTagOptions = [
    { label: "New Arrival", value: "New Arrival" },
    { label: "Hot", value: "Hot" },
    { label: "Best Seller", value: "Best Seller" },
    { label: "Limited Edition", value: "Limited Edition" },
    { label: "Exclusive", value: "Exclusive" },
    { label: "Sale", value: "Sale" },
    { label: "Featured", value: "Featured" },
    { label: "Premium", value: "Premium" },
    { label: "Special Offer", value: "Special Offer" },
    { label: "fdfs", value: "fdfs" },
    { label: "Trending", value: "Trending" }
  ];

  // 修改标签选择器的选项处理
  const [availableTagOptions, setAvailableTagOptions] = useState(defaultTagOptions);

  // Consolidated useEffect for loading product data and categories
  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        
        // Load product categories first
        const categoryOptions = await productCategoryList();
        setProductCategory([{ options: categoryOptions }]);

        // Load product details
        if (!productId) {
          errornotify("No product ID provided. Cannot load product data.");
          return;
        }
        
        const response = await fetchProductDetail(productId);
        if (response.status === 200) {
            const product = response.data.product;
            console.log('Loaded product data:', product);
            console.log('All product fields:', Object.keys(product));
            
            // Get NFC data
            loadProductNFC(product.id);
            setDetailData(product);

            // Set images with null checks
            if (product.editions && product.editions.length > 0 && product.editions[0].images) {
              const images = product.editions[0].images;
              
              // Set main image
              const mainImage = images.find(image => image.main_image === true);
              if (mainImage) {
                setMainImageUrl(`${baseURL}/file/product/image/${mainImage.image_url}`);
              }

              // Set other images
              const otherImages = images.map(image => ({
                id: image.id,
                preview: `${baseURL}/file/product/image/${image.image_url}`,
                url: `${baseURL}/file/product/image/${image.image_url}`,
                filename: image.image_url,
                main_image: image.main_image,
                name: image.image_url,
                formattedSize: ''
              }));
              setSelectedFiles(otherImages);
            }

            const edition = product.editions && product.editions.length > 0 ? product.editions[0] : {};
            
            // Debug manufacturer fields AFTER edition is defined
            console.log('Manufacturer fields from API:', {
              // Product level
              'product.manufacturer_name': product.manufacturer_name,
              'product.manufacturer_brand': product.manufacturer_brand,
              'product.manufacturerName': product.manufacturerName,
              'product.manufacturerBrand': product.manufacturerBrand,
              'product.manufacturer': product.manufacturer,
              'product.brand': product.brand,
              // Edition level
              'edition.manufacturer_name': edition.manufacturer_name,
              'edition.manufacturer_brand': edition.manufacturer_brand,
              // Final resolved values
              resolvedManufacturerName: product.manufacturer_name || edition.manufacturer_name || product.manufacturerName || "",
              resolvedManufacturerBrand: product.manufacturer_brand || edition.manufacturer_brand || product.manufacturerBrand || product.brand || ""
            });

            // Set NFT selection
            if (edition.nft !== undefined) {
              setSelectedNft({ 
                label: edition.nft ? "Yes" : "No", 
                value: edition.nft ? "yes" : "no" 
              });
            }

            // Set battery required selection
            if (edition.battery_required !== undefined) {
              setbattery_required({ 
                label: edition.battery_required ? "Yes" : "No", 
                value: edition.battery_required ? "yes" : "no" 
              });
            }

            // Set visibility selection
            if (product.visibility) {
              setselectedVisibility({ 
                label: product.visibility, 
                value: product.visibility 
              });
            }

            // Set rich text editor content
            if (product.description) {
              setAbout(product.description);
            }

            // Handle tags data
            if (product.tags && Array.isArray(product.tags)) {
              const existingTags = product.tags.map(tag => ({
                label: tag,
                value: tag
              }));
              
              // Merge existing tags with default options
              const allOptions = [...defaultTagOptions];
              existingTags.forEach(tag => {
                if (!allOptions.some(option => option.value === tag.value)) {
                  allOptions.push(tag);
                }
              });
              
              setAvailableTagOptions(allOptions);
              setSelectedTags(existingTags);
            }

            // Handle genres array
            const genreStr = product.genres ? product.genres.join(', ') : '';

            // Set all form values
            console.log('Setting form values with manufacturer data:', {
              manufacturer_name: product.manufacturer_name,
              manufacturer_brand: product.manufacturer_brand
            });
            
            // Set values directly and update touched to prevent validation issues
            const formValues = {
              name: product.name || "",
              price: edition.price || "",
              stock: edition.stock || "",
              orders: product.orders || "",
              category: product.category_id ? product.category_id.toString() : "",
              status: product.status || "",
              manufacturer_name: edition.manufacturer_name || "",
              manufacturer_brand: edition.manufacturer_brand || "",
              productDiscount: edition.discount || "",
              sku: edition.sku || "",
              total_units: edition.total_units || 0,
              type: product.type || "",
              box_content: edition.box_content || "",
              brand: product.brand || "",
              subBrand: product.subbrand || "", // Note: using 'subbrand' to match API
              series: edition.edition_name || "",
              battery_type: edition.battery_type || "",
              battery_capacity: edition.battery_capacity || "",
              age_limit: edition.age_limit || "",
              genre: genreStr,
              color: edition.color || "",
              artist: edition.artist || "",
              artist_link: edition.artist_link || "",
              affiliation: product.affiliation || "",
              madein: product.madein || "",
              weight: edition.weight || "",
              dimension: edition.dimension || "",
              boxsize: edition.boxsize || "",
              shipping_weight: edition.shipping_weight || "",
              vendorId: product.vendor_id || "",
              date: product.date || "",
              material: edition.material || "",
              product_short_description: product.short_description || "",
              publishedDate: product.publishedDate || date,
              nft_link: edition.nft_link || "",
            };
            
            // Force update form values
            validation.setValues(formValues);
            validation.setTouched({});
            
            // Debug: Check if values were set correctly
            setTimeout(() => {
              console.log('Form values after setValues:', {
                manufacturer_name: validation.values.manufacturer_name,
                manufacturer_brand: validation.values.manufacturer_brand
              });
            }, 100);
          } else {
            errornotify(response.message || "Failed to get product detail. Please try again.");
          }
      } catch (error) {
        console.error("Error loading data:", error);
        errornotify("Failed to load product data. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [productId]); // Remove detail from dependencies to prevent infinite loop 
  // Updated function to use customer-friendly NFC endpoint
  const loadProductNFC = async (productId) => {
    try {
      console.log('Loading NFC data for product:', productId);
      const response = await getProductNFC(productId);   
      
      if(response.status === 200 && response.data?.success){ 
        console.log('NFC response data:', response.data);
        if(response.data.data && response.data.data.length > 0){
          setNfcId(response.data.data[0].uid);
          setNfcIdold(response.data.data[0].uid);
          console.log('NFC UID set:', response.data.data[0].uid);
        } else {
          console.log('No NFC tags found for this product');
          setNfcId("");
          setNfcIdold("");
        }
      }
      else {
        console.log('NFC API response:', response);
        // Don't show error notification for no NFC tags, as it's normal
        if (response.data?.message && !response.data?.message.includes('No NFC')) {
          errornotify(response.data?.message || 'Failed to fetch NFC data'); 
        }
        setNfcId("");
        setNfcIdold("");
      }
    }
    catch (error) {
      console.error('Error fetching NFC data:', error); 
      // Don't show error notification for network issues when fetching NFC
      setNfcId("");
      setNfcIdold("");
    }
  }
  // Function to handle main product image upload
  const handleMainImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setIsUploading(true);
    const formData = new FormData();
    formData.append("image", file);
    formData.append("is_main_image", 1); 

    try {
       
      const response = await addProductImage(formData);
      // const response = await axios.post("/api/upload", formData, {
      //   headers: { "Content-Type": "multipart/form-data" },
      // });

      if (response.filename) {
        setMainImageUrl(`${baseURL}/file/product/image/${response.filename}`); // Store uploaded image URL
      }
    } catch (error) {
      console.error("Upload main image failed:", error);
    } finally {
      setIsUploading(false);
    }
  };


const handleImageListUpload = async (files) => {
    if (!files.length) return;

    const formData = new FormData();
    
    // Append multiple files
    files.forEach(file => {
        formData.append("file", file);
    });

    const response = await addProductImageList(formData);

    if (response && response.success) {
        // Map response URLs back to the original file object schema
        const updatedFiles = files.map((file, index) => ({
            ...file,
            id: file.id,
            preview: URL.createObjectURL(file),
            formattedSize: formatBytes(file.size),
            url: response.images[index]?`${baseURL}/file/product/image/${response.images[index]}`: file.url, // Use returned URL if available
            filename: response.images[index]
        }));

        setSelectedFiles(updatedFiles);
    }
};


  async function deleteImg(filename){
    try {
        const response = await delProductImg(filename);
      
      // Check if response exists and has expected structure
      if (!response) {
        throw new Error('No response received from server');
      }
  
      // Handle successful response
      if (response.success) {
        alert("Product delete successfully");
        // Optionally reset form or redirect
        // validation.resetForm();
        // navigate('/products'); // If you want to redirect after success
      } else {
        // Handle API error with message
        alert(response.message || "Failed to delete product. Please try again.");
      }
    } catch (err) {
      console.error('Submission failed:', err);
      
      // User-friendly error message
      alert(
        err.response?.message || 
        err.message || 
        'Failed to delete product. Please check your connection and try again.'
      );
    }
  }
  function handleSelectNft(selectedNft) { 
    setSelectedNft(selectedNft);
}

  function handleSelectVisibility(selectedVisibility) {
    setselectedVisibility(selectedVisibility);
  }
  function handleSelectbattery_required(selectedOption) {
    setbattery_required(selectedOption);
  }
  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }


// Function to process the product categories
const productCategoryList = async () => {
  try {
    const response = await fetchProductCategories();
    if (response.status === 200) {
      const options = response.data.map(category => ({
        value: category.id.toString(),
        label: category.name
      }));
      return options;
    }
    return [];
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};


// React useEffect to populate product categories
const [productCategory, setProductCategory] = React.useState([
  {
    options: [
      { label: "All", value: "All" }, // Default initial option
    ],
  },
]);

  // Note: Duplicate useEffect removed - data loading consolidated above


  const yesOrNo = [
    {
      options: [
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" }
      ],
    },
  ];

  const dateFormat = () => {
    let d = new Date(),
      months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let h = (d.getHours() % 12) || 12;
    let ampm = d.getHours() < 12 ? "AM" : "PM";
    return ((d.getDate() + ' ' + months[d.getMonth()] + ', ' + d.getFullYear() + ", " + h + ":" + d.getMinutes() + " " + ampm).toString());
  };

  const [date, setDate] = useState(dateFormat());

  const dateformate = (e) => {
    const dateString = e.toString().split(" ");
    let time = dateString[4];
    let H = +time.substr(0, 2);
    let h = (H % 12) || 12;
    h = (h <= 9) ? h = ("0" + h) : h;
    let ampm = H < 12 ? "AM" : "PM";
    time = h + time.substr(2, 3) + " " + ampm;

    const date = dateString[2] + " " + dateString[1] + ", " + dateString[3];
    const orderDate = (date + ", " + time).toString();
    setDate(orderDate);
  }; 
  const productStatus = [
    {
      options: [
        { label: "Draft", value: "draft" },
        { label: "Published", value: "published" },
        { label: "Scheduled", value: "scheduled" },
      ],
    },
  ];

  const productVisibility = [
    {
      options: [
        { label: "Hidden", value: "Hidden" },
        { label: "Public", value: "Public" },
      ],
    },
  ];
  const validation = useFormik({
    enableReinitialize: false, // Temporarily disable to test

    initialValues: { 
      name: "",
      price: "",
      stock: "",
      orders: "",
      category: "",
      status: "",
      manufacturer_name: "",
      manufacturer_brand: "",
      productDiscount: "",
      sku: "",
      total_units: "",
      type: "",
      box_content: "",
      brand: "",
      subBrand: "",
      series: "",
      battery_type: "",
      battery_capacity: "",
      age_limit: "",
      genre: "",
      color: "",
      artist: "",
      artist_link: "",
      affiliation: "",
      madein: "",
      weight: "",
      dimension: "",
      boxsize: "",
      shipping_weight: "",
      vendorId: "",
      date: "",
      material: "",
      product_short_description: "",
      publishedDate: "",
      nft_link: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter a Product Title"),
      price: Yup.number().positive("Price must be positive").required("Please Enter a Product Price"),
      stock: Yup.number().integer("Stock must be an integer").min(0, "Stock cannot be negative").required("Please Enter a Product stock"),
      orders: Yup.number().integer("Orders must be an integer").min(0, "Orders cannot be negative").nullable(),
      category: Yup.string().required("Please Enter a Product category"),
      status: Yup.string().required("Please Enter a Product status"),
      manufacturer_name: Yup.string().required("Please Enter a Manufacturer Name"),
      manufacturer_brand: Yup.string().required("Please Enter a Manufacturer Brand"),
      productDiscount: Yup.number().min(0, "Discount cannot be negative").max(100, "Discount cannot exceed 100%").nullable(),
      sku: Yup.string().required("Please Enter a Product SKU"),
      total_units: Yup.number()
        .integer('Must be an integer')
        .min(1, 'Must be at least 1')
        .required("Please Enter Total Units")
        .typeError('Must be a valid number'),
      type: Yup.string(),
      box_content: Yup.string(),
      brand: Yup.string(),
      subBrand: Yup.string(),
      series: Yup.string(),
      battery_type: Yup.string(),
      battery_capacity: Yup.string(),
      age_limit: Yup.string(),
      genre: Yup.string(),
      color: Yup.string(),
      artist: Yup.string(),
      artist_link: Yup.string().url("Must be a valid URL"),
      affiliation: Yup.string(),
      madein: Yup.string(),
      weight: Yup.string(),
      dimension: Yup.string(),
      boxsize: Yup.string(),
      shipping_weight: Yup.string(),
      vendorId: Yup.string(),
      date: Yup.string(),
      material: Yup.string(),
      product_short_description: Yup.string(),
      publishedDate: Yup.string(),
      nft_link: Yup.string().url("Must be a valid URL"),
    }),  
     
  });

  const navigate = useNavigate();

  const handleTagsChange = (newValue) => {
    setSelectedTags(newValue || []);
  };

  // 处理创建新标签
  const handleCreateTag = (inputValue) => {
    const newOption = { label: inputValue, value: inputValue };
    setAvailableTagOptions([...availableTagOptions, newOption]);
    setSelectedTags([...selectedTags, newOption]);
  };

  // 添加通知函数
  const notify = () => toast.success("Product Updated Successfully!", { position: "top-right", autoClose: 3000 });
  const successnotify = (message) => toast.success(message || "Operation Successful!", { position: "top-right", autoClose: 3000 });

  const handleSubmit = async (values) => {
    try { 
      // Validation: Ensure detail data is loaded
      if (!detail || !detail.id) {
        errornotify("Product data not loaded yet. Please wait and try again.");
        return;
      }

      // Validation: Check if productId exists
      if (!productId) {
        errornotify("Invalid product ID. Cannot update product.");
        return;
      }

      const newProduct = {
        id: detail.id,
        name: values.name,
        price: values.price,
        stock: values.stock,
        orders: values.orders,
        category_id: parseInt(values.category),
        publishedDate: date,
        status: values.status,
        rating: 4.5,
        nft: selectedNft ? selectedNft.value === "yes" : false,
        description: about,
        manufacturer_name: values.manufacturer_name,
        manufacturer_brand: values.manufacturer_brand,
        type: values.type,
        box_content: values.box_content,
        brand: values.brand,
        subbrand: values.subBrand,
        series: values.series,
        genre: values.genre ? values.genre.split(',').map(g => g.trim()) : [],
        editions: [{
          color: values.color,
          price: parseFloat(values.price),
          stock: parseInt(values.stock),
          total_units: parseInt(values.total_units),
          discount: parseFloat(values.productDiscount),
          sku: values.sku,
          weight: values.weight,
          dimension: values.dimension,
          boxsize: values.boxsize,
          shipping_weight: values.shipping_weight,
          artist: values.artist,
          artist_link: values.artist_link,
          battery_type: values.battery_type,
          age_limit: values.age_limit,
          battery_capacity: values.battery_capacity,
          battery_required: battery_required ? battery_required.value === "yes" : false,
          nft: selectedNft ? selectedNft.value === "yes" : false,
          nft_link: values.nft_link,
          material: values.material,
          visible: selectedVisibility ? selectedVisibility.value === "Public" : true, // Convert to boolean: true for "Public", false for "Hidden"
        }],
        affiliation: values.affiliation,
        madein: values.madein,
        vendorId: values.vendorId,
        date: values.date,
        visibility: selectedVisibility ? selectedVisibility.value === "Public" : true, // Convert to boolean: true for "Public", false for "Hidden"
        publishedDate: values.publishedDate,
        tags: selectedTags.map(tag => tag.value),
        short_description: values.product_short_description,
        product_main_image: mainImageUrl ? mainImageUrl.substring(mainImageUrl.lastIndexOf('/') + 1) : '',
        product_other_images: selectedFiles.map((file) => file.url ? file.url.substring(file.url.lastIndexOf('/') + 1) : file.filename)
      };
  
      // Make API call with error handling
      const response = await updateProduct(newProduct);
      debugger
      // Check if response exists and has expected structure 
      // Handle successful response
      if (response.status) { 
        
        debugger
        if(nfcId){
          const nfc_payload={
            tag_type:"product",
            assigned_id:response.product?.id || detail.id,
            uid:nfcId 
        }
         let response2;
         if (nfcIdold){
          response2 =  await  nfcUpdate( nfcIdold, nfc_payload); 
         }
         else{
            response2 =  await  nfcAdd(nfc_payload); 
         }
         if(response2.status){
          successnotify("Product added successfully");
          navigate('/my-product-list'); 
         }
        }else{
          successnotify("Product added successfully");
          navigate('/my-product-list');
        } 
        // Optionally reset form or redirect
        // validation.resetForm();
        // navigate('/products'); // If you want to redirect after success
      } else {
        debugger
        // Handle API error with message
          errornotify(response.response.data.error || "Failed to update product. Please try again.")  
      }
  
    } catch (err) {
      debugger
      console.error('Submission failed:', err);
      errornotify(err.response?.message || 
        err.message || 
        'Failed to update product. Please check your connection and try again.') 
      
      // User-friendly error message
      
    }
  }; 
    // Show loading state while data is being fetched
  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-center align-items-center" style={{minHeight: '400px'}}>
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <span className="ms-2">Loading product data...</span>
          </div>
        </Container>
      </div>
    );
  }

  // Show error state if no productId or detail data
  if (!productId || !detail) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-center align-items-center" style={{minHeight: '400px'}}>
            <div className="alert alert-danger" role="alert">
              <h4 className="alert-heading">Error!</h4>
              <p>{!productId ? 'No product ID provided.' : 'Failed to load product data.'}</p>
              <hr />
              <p className="mb-0">
                <Link to="/my-product-list" className="btn btn-primary">
                  Back to Products
                </Link>
              </p>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
      <ToastContainer />
        <BreadCrumb title="Edit Product" pageTitle="Ecommerce" />

        <Row>
          <Col lg={8}>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                console.log('onsubmit');
                
                // Check if detail data is loaded
                if (!detail || !detail.id) {
                  errornotify("Product data not loaded. Please wait and try again.");
                  return false;
                }
                
                // Submit the form directly for now
                console.log('Form values:', validation.values);
                console.log('Form errors:', validation.errors);
                handleSubmit(validation.values);
                
                return false;
              }}>
              <Card>
                <CardBody>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="product-title-input">
                      Product Title
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="product-title-input"
                      placeholder="Enter product title"
                      name="name"
                      value={validation.values.name || ""}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      invalid={validation.errors.name && validation.touched.name ? true : false}
                    />
                    {validation.errors.name && validation.touched.name ? (
                      <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                    ) : null}
                  </div>
                  <div>
                    <Label>Product Back Story</Label>

                    <CKEditor
                      editor={ClassicEditor}
                      data={about}
                      onReady={(editorInstance) => {
                        setEditor(editorInstance);
                        if (detail && detail.description) {
                          editorInstance.setData(detail.description);
                        }
                      }} 
                      onChange={(event, editor) => { 
                        const data = editor.getData();
                        if(data){
                          setAbout(data);
                        }
                      }}
                    />
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Product Gallery</h5>
                </CardHeader>
                <CardBody>
                  {/* <div className="mb-4">
                    <h5 className="fs-15 mb-1">Product Image</h5>
                    <p className="text-muted">Add Product main Image.</p>
                    <div className="text-center">
                      <div className="position-relative d-inline-block">
                        <div className="position-absolute top-100 start-100 translate-middle">
                          <label htmlFor="product-image-input" className="mb-0" data-bs-toggle="tooltip" data-bs-placement="right" title="" data-bs-original-title="Select Image">
                            <div className="avatar-xs">
                              <div className="avatar-title bg-light border rounded-circle text-muted cursor-pointer">
                                <i className="ri-image-fill"></i>
                              </div>
                            </div>
                          </label>
                          <input className="form-control d-none" defaultValue="" id="product-image-input" type="file" accept="image/png, image/gif, image/jpeg" />
                        </div>
                        <div className="avatar-lg">
                          <div className="avatar-title bg-light rounded">
                            <img src="" id="product-img" alt="" className="avatar-md h-auto" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  {/* Product Image Upload */}
                  <div className="mb-4">
                    <h5 className="fs-15 mb-1">Product Image</h5>
                    <p className="text-muted">Upload the main product image.</p>
                    <div className="text-center">
                      <div className="position-relative d-inline-block">
                        <div className="position-absolute top-100 start-100 translate-middle">
                          <label htmlFor="product-image-input" className="mb-0">
                            <div className="avatar-xs">
                              <div className="avatar-title bg-light border rounded-circle text-muted cursor-pointer">
                                <i className="ri-image-fill"></i>
                              </div>
                            </div>
                          </label>
                          <input
                            className="form-control d-none"
                            id="product-image-input"
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={handleMainImageUpload}
                          />
                        </div>
                        <div className="avatar-lg">
                          <div className="avatar-title bg-light rounded">
                            {mainImageUrl ? (
                              <img
                                src={mainImageUrl}
                                alt="Product"
                                className="avatar-md h-auto"
                              />
                            ) : (
                              <p className="text-muted">No image selected</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* end main  */}
                  <div>
                    <h5 className="fs-15 mb-1">Product Gallery</h5>
                    <p className="text-muted">Add Product Gallery Images.</p>

                    <Dropzone
                      onDrop={(acceptedFiles) => {
                        handleImageListUpload(acceptedFiles);
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone dz-clickable">
                          <div
                            className="dz-message needsclick"
                            {...getRootProps()}
                          >
                            <div className="mb-3">
                              <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                            </div>
                            <h5>Drop files here or click to upload.</h5>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <div className="list-unstyled mb-0" id="file-previews">
                      {selectedFiles.map((f, i) => {
                        return (
                          <Card
                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                          >
                            <div className="p-2">
                              <Row className="align-items-center">
                                <Col className="col-auto">
                                  <img
                                    data-dz-thumbnail=""
                                    height="80"
                                    className="avatar-sm rounded bg-light"
                                    alt={f.name}
                                    src={f.preview}
                                  />
                                </Col>
                                <Col>
                                  <Link
                                    to={f.url}
                                    target="_blank"
                                    className="text-muted font-weight-bold"
                                  >
                                    {f.name}
                                  </Link>
                                  <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                  </p>
                                </Col>
                                <Col>
                                  <i  onClick={() => {
                                      deleteImg(f.filename);
                                    }} className="ri-delete-bin-2-line float-end"></i>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        );
                      })}
                    </div>
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardHeader>
                  <Nav className="nav-tabs-custom card-header-tabs border-bottom-0">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "1",
                        })}
                        onClick={() => {
                          toggleCustom("1");
                        }}
                      >
                        General Info
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "2",
                        })}
                        onClick={() => {
                          toggleCustom("2");
                        }}
                      >
                        Meta Data
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardHeader>

                <CardBody>
                  <TabContent activeTab={customActiveTab}>
                    <TabPane id="addproduct-general-info" tabId="1">
                      <Row>
                        <Col lg={6}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="manufacturer-name-input"
                            >
                              Manufacturer Name
                            </label>
                            <Input
                              type="text"
                              className="form-control"
                              id="manufacturer-name-input"
                              name="manufacturer_name"
                              placeholder="Enter manufacturer name"
                              value={validation.values.manufacturer_name ?? ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              invalid={validation.errors.manufacturer_name && validation.touched.manufacturer_name ? true : false}
                            />
                            {validation.errors.manufacturer_name && validation.touched.manufacturer_name ? (
                              <FormFeedback type="invalid">{validation.errors.manufacturer_name}</FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="manufacturer-brand-input"
                            >
                              Manufacturer Brand
                            </label>
                            <Input
                              type="text"
                              className="form-control"
                              id="manufacturer-brand-input"
                              name="manufacturer_brand"
                              placeholder="Enter manufacturer brand"
                              value={validation.values.manufacturer_brand ?? ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              invalid={validation.errors.manufacturer_brand && validation.touched.manufacturer_brand ? true : false}
                            />
                            {validation.errors.manufacturer_brand && validation.touched.manufacturer_brand ? (
                              <FormFeedback type="invalid">{validation.errors.manufacturer_brand}</FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={3}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="product-stock-input"
                            >
                              release_number 
                            </label>
                            <div className="input-group mb-3">
                              <Input
                                type="text"
                                className="form-control"
                                id="product-stock-input"
                                placeholder="Enter release_number"
                                name="total_units"
                                value={validation.values.total_units || ""}
                                onBlur={validation.handleBlur}
                                onChange={validation.handleChange}
                                invalid={validation.errors.total_units && validation.touched.total_units ? true : false}
                              />
                              {validation.errors.total_units && validation.touched.total_units ? (
                                <FormFeedback type="invalid">{validation.errors.total_units}</FormFeedback>
                              ) : null}
                            </div>
                          </div>
                        </Col>

                        <Col sm={3}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="product-price-input"
                            >
                              Price
                            </label>
                            <div className="input-group mb-3">
                              <span
                                className="input-group-text"
                                id="product-price-addon"
                              >
                                $
                              </span>
                              <Input
                                type="text"
                                className="form-control"
                                id="product-price-input"
                                placeholder="Enter price"
                                name="price"
                                aria-label="Price"
                                aria-describedby="product-price-addon"
                                value={validation.values.price || ""}
                                onBlur={validation.handleBlur}
                                onChange={validation.handleChange}
                                invalid={validation.errors.price && validation.touched.price ? true : false}
                              />
                              {validation.errors.price && validation.touched.price ? (
                                <FormFeedback type="invalid">{validation.errors.price}</FormFeedback>
                              ) : null}
                            </div>
                          </div>
                        </Col>

                        <Col sm={3}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="product-Discount-input"
                            >
                              Discount
                            </label>
                            <div className="input-group mb-3">
                              <span
                                className="input-group-text"
                                id="product-Discount-addon"
                              >
                                %
                              </span>
                              <Input
                                type="text"
                                className="form-control"
                                id="product-Discount-input"
                                placeholder="Enter Discount"
                                name="productDiscount"
                                aria-label="productDiscount"
                                aria-describedby="product-orders-addon"
                                value={validation.values.productDiscount || ""}
                                onBlur={validation.handleBlur}
                                onChange={validation.handleChange}
                                invalid={validation.errors.productDiscount && validation.touched.productDiscount ? true : false}
                              />
                              {validation.errors.productDiscount && validation.touched.productDiscount ? (
                                <FormFeedback type="invalid">{validation.errors.productDiscount}</FormFeedback>
                              ) : null}
                            </div>
                          </div>
                        </Col>

                        <Col sm={3}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="product-orders-input"
                            >
                              SKU
                            </label>
                            <div className="input-group mb-3">
                              <Input
                                type="text"
                                className="form-control"
                                id="product-orders-input"
                                placeholder="Enter sku"
                                name="sku"
                                aria-label="sku"
                                aria-describedby="product-orders-addon"
                                value={validation.values.sku || ""}
                                onBlur={validation.handleBlur}
                                onChange={validation.handleChange}
                                invalid={validation.errors.sku && validation.touched.sku ? true : false}
                              />
                              {validation.errors.sku && validation.touched.sku ? (
                                <FormFeedback type="invalid">{validation.errors.sku}</FormFeedback>
                              ) : null}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>

                    <TabPane id="addproduct-metadata" tabId="2">
                       
                       
                      <Row>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Ntag Id
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter ntag id"
                              id="meta-title-input"
                              name="nfcId"
                              value={nfcId}
                              onChange={(e) => {
                                setNfcId(e.target.value);
                              }
                              }/>
                          </div>
                        </Col>

                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Type
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter type"
                              id="meta-title-input"
                              name="type"
                              value={validation.values.type || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Box Content 
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter box_content"
                              id="meta-title-input"
                              name="box_content"
                              value={validation.values.box_content || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col> 
                      </Row>
                      <Row> 
                        <Col lg={6}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Brand
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter brand"
                              id="meta-title-input"
                              name="brand"
                              value={validation.values.brand || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Sub Brand
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Ente sub_brand"
                              id="meta-title-input"
                              name="subBrand"
                              value={validation.values.subBrand || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                      </Row>
                      <Row> 
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Series
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter series"
                              id="meta-title-input"
                              name="series"
                              value={validation.values.series || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             NFT
                            </Label> 
                            <Select
                              value={selectedNft}
                              onChange={(selectedOption) => {
                                handleSelectNft(selectedOption);
                              }}
                              options={yesOrNo[0].options}
                              name="choices-nft-input"
                              classNamePrefix="select2-selection form-select"
                            />
                            

                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             NFT Link 
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter NFT Link"
                              id="nft-link-input"
                              name="nft_link"
                              value={validation.values.nft_link || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row> 
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Battery Required 
                            </Label>
                            <Select
                              value={battery_required} 
                              options={yesOrNo}
                              name="battery_required"
                              classNamePrefix="select2-selection form-select"
                              onChange={(selectedOption) => handleSelectbattery_required(selectedOption)}
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Baterry Type 
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter baterry_type"
                              id="meta-title-input"
                              name="battery_type"
                              value={validation.values.battery_type || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Battery Capacity  
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter battery_capacity"
                              id="meta-title-input"
                              name="battery_capacity"
                              value={validation.values.battery_capacity || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                      </Row>
                      <Row> 
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Age Limit 
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter age_limit"
                              id="meta-title-input"
                              name="age_limit"
                              value={validation.values.age_limit || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Genre  
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter genre"
                              id="meta-title-input"
                              name="genre"
                              value={validation.values.genre || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Color   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter series"
                              id="meta-title-input"
                              name="color"
                              value={validation.values.color || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                      </Row>
                      <Row> 
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Artist
 
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter artist"
                              id="meta-title-input"
                              name="artist"
                              value={validation.values.artist || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Artist Link   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter artist_link"
                              id="meta-title-input"
                              name="artist_link"
                              value={validation.values.artist_link || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Affiliation   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter affiliation"
                              id="meta-title-input"
                              name="affiliation"
                              value={validation.values.affiliation || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                      </Row>
                      <Row> 
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Made In 
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter madein"
                              id="meta-title-input"
                              name="madein"
                              value={validation.values.madein || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Category   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter v"
                              id="meta-title-input"
                              name="category"
                              value={validation.values.category || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Weight   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter weight"
                              id="meta-title-input"
                              name="weight"
                              value={validation.values.weight || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                      </Row>
                      <Row> 
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Product Dimension 
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter product_dimension"
                              id="meta-title-input"
                              name="dimension"
                              value={validation.values.dimension || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Box Size   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter box_size"
                              id="meta-title-input"
                              name="boxsize"
                              value={validation.values.boxsize || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Shipping Weight   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter shipping_weight"
                              id="meta-title-input"
                              name="shipping_weight"
                              value={validation.values.shipping_weight || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                      </Row>
                      <Row> 
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Vendor Id 
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter vendor_id"
                              id="meta-title-input"
                              name="vendorId"
                              value={validation.values.vendorId || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Date   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter date"
                              id="meta-title-input"
                              name="date"
                              value={validation.values.date || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Material   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter material"
                              id="meta-title-input"
                              name="material"
                              value={validation.values.material || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                      </Row> 

                       
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>

              <div className="text-end mb-3">
                <button 
                  type="submit" 
                  className="btn btn-primary w-sm"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Submit"}
                </button>
              </div>
            </Form>
          </Col>

          <Col lg={4}>
            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">Publish</h5>
              </CardHeader>
              <CardBody>
                <div className="mb-3">
                  <Label
                    htmlFor="choices-publish-status-input"
                    className="form-label"
                  >
                    Status
                  </Label>
                  <Input
                    name="status"
                    type="select"
                    className="form-select"
                    id="choices-publish-status-input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={
                      validation.values.status || ""
                    }
                  >
                    {productStatus.map((item, key) => (
                      <React.Fragment key={key}>
                        {item.options.map((item, key) => (<option value={item.value} key={key}>{item.label}</option>))}
                      </React.Fragment>
                    ))}
                  </Input>
                  {validation.touched.status &&
                    validation.errors.status ? (
                    <FormFeedback type="invalid">
                      {validation.errors.status}
                    </FormFeedback>
                  ) : null}
                </div>

                <div>
                  <Label
                    htmlFor="choices-publish-visibility-input"
                    className="form-label"
                  >
                    Visibility
                  </Label>

                  <Select
                    value={selectedVisibility}
                    onChange={(selectedOption) => {
                      handleSelectVisibility(selectedOption);
                    }}
                    options={productVisibility[0].options}
                    name="choices-publish-visibility-input"
                    classNamePrefix="select2-selection form-select"
                  />
                </div>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">Publish Schedule</h5>
              </CardHeader>

              <CardBody>
                <div>
                  <label
                    htmlFor="datepicker-publish-input"
                    className="form-label"
                  >
                    Publish Date & Time
                  </label>
                  <Flatpickr
                    name="publishedDate"
                    id="publishedDate-field"
                    className="form-control"
                    placeholder="Select a date"
                    options={{
                      enableTime: true,
                      altInput: true,
                      altFormat: "d M, Y, G:i K",
                      dateFormat: "d M, Y, G:i K",
                    }}
                    onChange={(e) =>
                      dateformate(e)
                    }
                    value={validation.values.publishedDate || ""}
                  />
                  {validation.touched.publishedDate && validation.errors.publishedDate ? (
                    <FormFeedback type="invalid">{validation.errors.publishedDate}</FormFeedback>
                  ) : null}
                </div>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">Product Categories</h5>
              </CardHeader>
              <CardBody>
                <p className="text-muted mb-2">
                  Select product category
                </p>

                <Input
                  name="category"
                  type="select"
                  className="form-select"
                  id="category-field"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.category || ""}
                >
                  <option value="">Select Category</option>
                  {productCategory[0]?.options?.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Input>
                {validation.touched.category && validation.errors.category ? (
                  <FormFeedback type="invalid">
                    {validation.errors.category}
                  </FormFeedback>
                ) : null}

                {/* 显示当前选择的分类路径 */}
                {validation.values.category && (
                  <div className="mt-2 text-muted small">
                    Current category path: {detail?.category || ""}
                  </div>
                )}
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">Product Tags</h5>
              </CardHeader>
              <CardBody>
                <div className="mb-3">
                  <Label className="form-label">Product Tags</Label>
                  <Select
                    isMulti
                    value={selectedTags}
                    onChange={handleTagsChange}
                    options={availableTagOptions}
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Enter tags"
                    isClearable
                    isCreatable
                    formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                    onCreateOption={handleCreateTag}
                  />
                </div>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">Product Short Description</h5>
              </CardHeader>
              <CardBody>
                <div className="hstack gap-3 align-items-start">
                  <div className="flex-grow-1">
                    <textarea
                      className="form-control"
                      placeholder="Optional: Add a short description for the product"
                      name="product_short_description"
                      rows="3"
                      value={validation.values.product_short_description || ""}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                    ></textarea>
                    {/* Optional fields do not require validation feedback */}
                  </div>
                </div>
              </CardBody>
            </Card>

          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EditProduct;
